import { useCallback } from 'react';

const MockFunction = () => {};
const InitialActions = () => ({
  getScheduledVisits: MockFunction,
  getPendingVisits: MockFunction
});

export const useVisitsActions = ({
  version = 1,
  actions = [InitialActions()]
}) => {
  const visitsGetter = useCallback((version) => {
    const API = new Map(actions.map((action, index) => [index + 1, action]));
    if (API.has(version)) return API.get(version);
    return API.get(1);
  }, [actions]);

  return visitsGetter(version);
};

export default useVisitsActions;
